<template>
	<div class="component-root">
	<div class="content_retix enedis-consent-start-view">
		<div class="container-retix">
			<div class="bloc_content">
				<h2>Autoriser Retix by EPG à accéder à mes données de consommation pour l’étude de votre projet photovoltaïque.</h2>

				<div class="logos-societes">
					<img class="logo-societe" src="../assets/images/logo-emeraude-solaire.jpeg" alt="Émeraude Solaire"/>
					<img class="logo-societe" src="../assets/images/logo-systemes-solaires.png" alt="Systèmes Solaires"/>
				</div>
				
				<p v-if="customMsg" v-html="customMsg"></p>
				
				<p>Enedis gère le réseau d’électricité jusqu’au compteur d’électricité.</p>
				
				<p>Pour que votre simulation soit la plus <b>précise et proche de la réalité</b>, 
					<span style="color:var(--bleu);">autorisez l’application Retix by EPG de la société Émeraude Power Group (Émeraude Solaire et Systèmes Solaires) 
						à accéder à vos données de consommation via votre compteur Linky.</span>
				</p>

				<p>Enedis est le gestionnaire du réseau public de distribution d’électricité sur 95% du territoire français continental.</p>
				
				<p>Pour continuer, cliquez sur le bouton suivant, vous allez accéder à votre compte personnel Enedis 
					où vous pourrez donner votre accord pour qu’Enedis nous transmette vos données.</p>
				
				<p>Cette autorisation est valable pour {{consent.durationMonth}} mois.</p>
				<p class="aide-pdf">Besoin d'aide ? <a href="/mode-operatoire-enedis-particulier.pdf" target="_blank" rel="noopener">Consultez le mode opératoire (PDF)</a>.</p>
				
				<p class="enedis-button-parent">

					<b-button class="enedis-button" @click.prevent="startEnedis">
						<img class="enedis-picto-compact" src="../assets/images/picto-enedis-compact-e-bleu-fd-blanc.png"/>
						<span class="btn-text">J'autorise Retix by EPG via mon espace client Enedis</span>
					</b-button>
					
				</p>
			</div><!-- class="bloc_content" -->
		</div><!-- class="container-retix" -->
	</div><!-- class="content_retix enedis-consent-start-view"-->
	
	<div class="enedis-frame-view">
		<div class="short-header">
			<div class="logo-container"><img class="logo-img" src="../assets/images/logo_retix.svg" alt="Logo Retix" height="30" width="105" border="0" /></div>
			<div class="lost-msg">
				Perdu chez Enedis ? 
			</div><!-- class="lost-msg" --> 
			<div class="restart-btn-container">
				<b-button variant="outline-primary" size="sm" class="btn-white">Recommencer</b-button>
			</div><!-- class="lost-msg" --> 
		</div><!-- class="short-header" -->
		<div id="enedis-frame-container">
			<iframe :src="startLink" :width="iframeWidth" :height="iframeHeight" >
				
			</iframe>
		</div><!-- id="enedis-frame-container" -->
	</div><!-- class="enedis-frame-view" -->
	 
	</div><!-- class="component-root" -->
</template>
<style>
	.enedis-frame-view { display:none; }
	.component-root {
		height:100vh;
	}
</style>
<style scoped>

.enedis-frame-view {
	flex-direction:column;
	align-items:stretch;
}

.short-header {
	height:50px;
	background-color:var(--bleu);
	display:flex;
	flex-direction:row;
	align-items:center;
	padding:0 10px;
	gap:10px;
	color:#FFF;
}

.lost-msg { 
	text-align:right;
	line-height:1.25;
	flex-grow:1; 
}

.btn-white {
	color:#FFF;
	border-color:#FFF;
	background-color:var(--bleu);
	
	&:hover {
		background-color:#1abcff;
		border-color:#FFF;
	}
}

#enedis-frame-container {
	flex-grow:1;	
}

.content_retix {
	display:flex;
	flex-direction: column;	
}



h2 {
	font-size:1.5rem;
	margin-bottom: 1.5rem;
}

.aide-pdf { font-size:0.9rem; }
.enedis-button-parent {
	display:flex;
	flex-direction:column;
	align-items:center;
}

/* Logos Émeraude Solaire et Systèmes Solaires : 40 px de haut (09/10/2026). Hors du bloc .enedis-button : rangées à
   l'intérieur depuis le lot 7, ces règles ne s'appliquaient pas et les logos s'affichaient en taille réelle. */
.logos-societes { display:flex; flex-wrap:wrap; align-items:center; gap:20px; margin:10px 0 16px; }
img.logo-societe { height:40px; width:auto; max-width:45%; object-fit:contain; }

.enedis-button {
	
	padding:1rem;
	display:flex;
	align-items:center;
	flex-direction:row;
	gap:1rem;
	background-color:#005eb8;
	border-radius: 12px;
	border:0;
	
	&:hover, &:active, &:focus, &:visited, &:target { background-color:#005eb8; }
	 
	
	img.enedis-picto-compact {
		width:30px;
		height:30px;
		border-radius: 6px 6px 6px 0;
	}
	
	.btn-text { font-weight:bold; }
}


.container-retix {
	width:800px;
	padding:0;
	align-self: center;
}

@media (max-width: 800px){
	/* Partie css mobile  */
	.container-retix { width:100%; }
	
	.bloc_content { border-radius:0; }
}



</style>
<script>
import { Icon } from 'element-ui';
import {enedisConsentService} from '../services/enedisConsent';
import utils  from '../utils/util.ts'
import Vue from 'vue';

export default {

	props:	{
	},//props:	{
	
	data(){
		return {
			code:null,
			consent: {
				code:null,
				durationMonth:0,
				informationMessage:null,
			},
			customMsg:null,
			startLink:null,
			iframeContainer:null,
			iframeWidth:null,
			iframeHeight:null,
		};
	},//data(){
	
	mounted() {		
		this.code = this.$route.params.code
		//console.log("views/EnedisConsentStart.vue:mounted()",this.$route)

		window.addEventListener("resize",this.updateIframeSize.bind(this))
		this.iframeContainer = document.getElementById("enedis-frame-container")
		this.updateIframeSize()
		
		let getForStartPromise = enedisConsentService.start(this.code )
		let successHandler = this.getForStartSuccess.bind(this)
		let errorHandler = this.restError.bind(this)
		getForStartPromise.then(successHandler).catch(errorHandler)
	},// mounted() {
	
	
	
	methods : {
		getForStartSuccess(response){
			this.consent = response.data
			this.customMsg = null
			if(this.consent.informationMessage != null ){
				this.customMsg = utils.textToHtml(this.consent.informationMessage)
			}
		},// getForStartSuccess(){
		
		restError(error){
			let errorMessage = error.response.data.exception.message
			if(errorMessage)
				Vue.toasted.error(errorMessage);
			else
				Vue.toasted.error(error);
		},//restError(){
			
		startEnedis(){
			let getStartLinkPromise = enedisConsentService.startLink(this.code )
			let successHandler = this.getStartLinkSuccess.bind(this)
			let errorHandler = this.restError.bind(this)
			getStartLinkPromise.then(successHandler).catch(errorHandler)
		},// startEnedis(){
			
		getStartLinkSuccess(response){
			console.log("views/EnedisConsentStart.vue:getStartLinkSuccess()",response)
			this.startLink = response.data
			let html = document.querySelector("html")
			//html.classList.add("enedis-frame-layout")
			
			window.open(this.startLink,'_blank');
		},//getStartLinkSuccess(){
		
			
		
		updateIframeSize(){
			let rect = this.iframeContainer.getBoundingClientRect()
			//console.log("views/EnedisConsentStart.vue:updateIframeSize()",rect)
			this.iframeWidth = rect.width
			this.iframeHeight = rect.height
		},//handleResize(){
	}//methods : {
}
</script>
